/* Default locations to pass the auth actions wrapper */

export let locations = {
    endpointUrl: process.env.REACT_APP_AP_API_URL,
    originUrl: process.env.PUBLIC_URL,
    redirectUrl: process.env.REACT_APP_AP_URL, 
    forbiddenUrl: process.env.REACT_APP_AP_URL,
    loginUrl: process.env.REACT_APP_AP_API_URL + '/Account/Login',
    tokenUrl: process.env.REACT_APP_AP_API_URL + '/Account/RequestAgentPortalAuthToken'
};


// WEBPACK FOOTER //
// ./src/features/common/redux/action_locations.js